import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ImplementerSnapshotSummary } from '../../../../models/implementer/implementer.models';
import { AppConfig } from '../../../../app/app.config';

@IonicPage()
@Component({
  selector: 'implementer-cancel-page',
  templateUrl: 'implementer-cancel-page.html',
})
export class ImplementerCancelPage {
  snapshotSummary: ImplementerSnapshotSummary;

  config = AppConfig.settings;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
  ) {
    this.snapshotSummary = this.navParams.get('snapshotSummary');
  }

  ionViewDidLoad() {
  }

  goBackClicked() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/implementer/implementer-cancel/implementer-cancel/implementer-cancel-page.ts